import axios from "axios";
import queryString from "query-string";
import { HTTP_TIMEOUT_DURATION } from "@root/constants/auth";
import { LocalStorageService } from "../local-storage";
import "./interceptors";
import { store } from "@root/store";
import { getCurrentLanguage } from "@root/store/selectors/features";

const localStorageService = new LocalStorageService();
export class HttpService {
  getTimeOutDuration() {
    return HTTP_TIMEOUT_DURATION;
  }

  async getHeaders(
    options?: IHttpRequestOptions,
    removeToken?: boolean
  ): Promise<Record<string, string>> {
    let headers: Record<string, string> = {};

    const language = getCurrentLanguage(store.getState());
    const token = await localStorageService.fetch("authToken");

    if (options && options?.headers && !options?.headers?.removeLanguage) {
      const { headers: customHeaders } = options;
      headers = customHeaders;
    }

    if (
      token &&
      typeof token === "string" &&
      !headers.Authorization &&
      !removeToken
    ) {
      headers.Authorization = `${"Bearer"} ${token}`;
    }

    if (!headers["Content-Type"]) {
      headers["Content-Type"] = "application/json";
    }

    if (!options?.headers?.removeLanguage) {
      if (language) headers.language = language?.toLowerCase();
    }

    return headers;
  }

  async get(
    url: string,
    queryParams: Record<string, any> | null = null,
    options?: IHttpRequestOptions,
    timeOut?: number
  ): Promise<any> {
    const headers: Record<string, string> = await this.getHeaders(options);
    return axios.get(url, {
      params: queryParams,
      paramsSerializer: function (params) {
        return queryString.stringify(params);
      },
      headers,
      timeout: timeOut ? timeOut : this.getTimeOutDuration(),
    });
  }

  async post(
    url: string,
    postData: unknown,
    options?: IHttpRequestOptions,
    timeOut?: number
  ): Promise<unknown> {
    const headers: Record<string, string> = await this.getHeaders(options);
    return axios.post(url, postData, {
      headers,
      responseType: (options as any)?.responseType,
      timeout: timeOut ? timeOut : this.getTimeOutDuration(),
    });
  }

  async put(
    url: string,
    postData: unknown,
    queryParams: Record<string, any> | null = null,
    options?: IHttpRequestOptions,
    removeToken?: boolean,
    timeOut?: number
  ): Promise<unknown> {
    const headers: Record<string, string> = await this.getHeaders(
      options,
      removeToken
    );

    return axios.put(url, postData, {
      params: queryParams,
      paramsSerializer: function (params) {
        return queryString.stringify(params);
      },
      headers,
      timeout: timeOut ? timeOut : this.getTimeOutDuration(),
    });
  }

  async patch(
    url: string,
    postData: unknown,
    options?: IHttpRequestOptions,
    timeOut?: number
  ): Promise<unknown> {
    const headers: Record<string, string> = await this.getHeaders(options);

    return axios.patch(url, postData, {
      headers,
      timeout: timeOut ? timeOut : this.getTimeOutDuration(),
    });
  }

  async delete(
    url: string,
    options?: IHttpRequestOptions,
    timeOut?: number,
    data?: TObject
  ): Promise<unknown> {
    const headers: Record<string, string> = await this.getHeaders(options);

    return axios.delete(url, {
      data,
      headers,
      timeout: timeOut ? timeOut : this.getTimeOutDuration(),
    });
  }
}
